import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { createContext, ReactNode, useContext } from 'react';
import { DashboardApi } from '../services/dashboard-api';
import { DashboardData } from '../types/dashboard-data';

const UserInfoContext = createContext<UseQueryResult<DashboardData, Error> | undefined>(undefined);

export const USER_INFO_QUERY_KEY = ['userInfo'] as const;

export const UserInfoProvider = ({ children }: { children: ReactNode }) => {
  const queryResult: UseQueryResult<DashboardData, Error> = useQuery({
    queryKey: USER_INFO_QUERY_KEY,
    queryFn: () => DashboardApi.getUserInfo(),
    refetchInterval: 60000, // refetch every minute
    retry: (failureCount: number, error: AxiosError) => {
      if (error?.response?.status === 401) {
        return false;
      }

      return failureCount < 5;
    },
  });

  return (
    <UserInfoContext.Provider value={queryResult}>
      {children}
    </UserInfoContext.Provider>
  );
};

export const useUserInfo = () => {
  const context = useContext(UserInfoContext);

  if (!context) {
    throw new Error('useUserInfo must be used within an UserInfoProvider');
  }

  return context;
};
